import React, { useState } from 'react';
import './AksesuarlarSection.css';

const AksesuarlarSection: React.FC = () => {
  const [selectedAksesuar, setSelectedAksesuar] = useState('varoma');

  const aksesuarlar = [
    {
      id: 'varoma',
      name: 'Varoma Seti',
      icon: 'akilliyemekrobotu-thermomix-tm7-varoma.webp',
      description: 'Varoma, malzemelerinizin eşit şekilde ısıtılması ve buharda pişirilmesi için Thermomix TM7\'nın üzerine oturacak şekilde tasarlanmıştır. İki katmanlı tam sızdırmaz bir tepsi ve kapağa sahip olan bu aksesuar, çok seviyeli pişirmeye olanak tanıyarak buharda pişirilmiş yemeklerin tamamını oluşturmanızı sağlar ve elinizin altında bulunan keyifli yemeklerle mutfak deneyiminizi geliştirir. Varoma® kapağı, tabağı ve tepsisinden oluşur. Dikdörtgen şekli, alanın verimli bir şekilde kullanılmasını sağlayarak sebzeleri, eti, balığı, kekleri ve ekmeği nazikçe ve kolayca buharda pişirmek için idealdir. Varoma, TM6\'ya kıyasla %45 daha fazla buharda pişirme kapasitesi sağlamak üzere yeniden tasarlanmıştır. Thermomix TM7 Varoma setinin toplam kapasitesi (tepsi ile birlikte) 6,8 litredir.'
    },
    {
      id: 'suzgec',
      name: 'Süzgeç',
      icon: 'akilliyemekrobotu-thermomix-tm7-suzgec.webp',
      description: 'Thermomix TM7 süzgeç aksesuarı, sıvıları katılardan ayırmak için kullanılır. Özellikle makarna, sebze ve diğer yiyecekleri süzmek için idealdir. Paslanmaz çelikten üretilmiştir ve kolay temizlenir.'
    },
    {
      id: 'karistirma-kabi',
      name: 'Karıştırma Kabı',
      icon: 'akilliyemekrobotu-thermomix-tm7-karistirma-kabi.webp',
      description: 'Karıştırma kabı, daha büyük miktarlarda malzeme karıştırmak için kullanılır. Özellikle hamur yoğurma ve büyük porsiyonlar için idealdir. Termal camdan üretilmiştir ve ısıya dayanıklıdır.'
    },
    {
      id: 'spatula',
      name: 'Spatula',
      icon: 'akilliyemekrobotu-thermomix-tm7-spatula.webp',
      description: 'Thermomix TM7 spatulası, karıştırma kabındaki malzemeleri temizlemek ve karıştırmak için kullanılır. Silikon uçlu olup, yapışmaz yüzeylere zarar vermez. Ergonomik tasarımı ile kullanımı kolaydır.'
    },
    {
      id: 'cirpma-teli',
      name: 'Çırpma Teli',
      icon: 'akilliyemekrobotu-thermomix-tm7-cirpma-teli.webp',
      description: 'Çırpma teli, yumurta, krema ve diğer sıvıları çırpmak için kullanılır. Paslanmaz çelikten üretilmiştir ve kolay temizlenir. Özellikle köpük oluşturma işlemleri için idealdir.'
    },
    {
      id: 'karistirma-kabi-kapagi',
      name: 'Karıştırma Kabı Kapağı',
      icon: 'akilliyemekrobotu-thermomix-tm7-karistirma-kabi-kapagi.webp',
      description: 'Karıştırma kabı kapağı, karıştırma sırasında sıçramaları önler ve ısıyı korur. Şeffaf yapısı sayesinde karıştırma işlemini gözlemleyebilirsiniz. Kolay takılıp çıkarılabilir.'
    },
  ];

  return (
    <section id="aksesuarlar" className="aksesuarlar-section">
      <div className="aksesuarlar-container">
        <div className="aksesuarlar-content">
          <div className="aksesuarlar-video">
            <video preload="none" playsInline loop autoPlay muted className="aksesuar-video">
              <source src="/assets/img/tm7/akilliyemekrobotu-thermomix-tm7-aksesuarlari.webm" type="video/webm" />
              <source src="/assets/img/tm7/akilliyemekrobotu-thermomix-tm7-aksesuarlari.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="aksesuarlar-info">
            <h2 className="aksesuarlar-title">
              <span className="highlight">THERMOMİX TM7</span><br />
              AKSESUARLARI
            </h2>
            <h3 className="aksesuar-selected-title">
              {aksesuarlar.find(a => a.id === selectedAksesuar)?.name}
            </h3>
            <p className="aksesuar-description">
              {aksesuarlar.find(a => a.id === selectedAksesuar)?.description}
            </p>
            <div className="aksesuarlar-grid">
              {aksesuarlar.map((aksesuar) => (
                <div
                  key={aksesuar.id}
                  className={`aksesuar-card ${selectedAksesuar === aksesuar.id ? 'active' : ''}`}
                  onClick={() => setSelectedAksesuar(aksesuar.id)}
                >
                  <div className="aksesuar-icon-container">
                    <img
                      src={`/assets/img/aksesuar/${aksesuar.icon}`}
                      alt={aksesuar.name}
                      className="aksesuar-icon"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AksesuarlarSection;

